import React from 'react';
import PracticesList from './PracticesList/PracticesList';

const PracticeManagement = () => {
  return (
    <div className="practice-management-container">
      <PracticesList />
    </div>
  );
};

export default PracticeManagement;
